/**
 * Utility to dynamically update meta tags for social sharing
 */

/**
 * Updates the Open Graph and Twitter meta tags for a specific SNAP
 * @param title The title of the SNAP
 * @param description The description of the SNAP
 * @param imageUrl The URL of the card image
 * @param url The URL of the SNAP
 */
export function updateMetaTags(
  title: string,
  description: string,
  imageUrl: string,
  url: string
): void {
  // Update Open Graph meta tags
  updateMetaTag('og:title', title);
  updateMetaTag('og:description', description);
  updateMetaTag('og:image', imageUrl);
  updateMetaTag('og:url', url);
  updateMetaTag('og:image:width', '1200');
  updateMetaTag('og:image:height', '630');
  updateMetaTag('og:type', 'article');
  
  // Update Twitter meta tags
  updateMetaTag('twitter:card', 'summary_large_image');
  updateMetaTag('twitter:title', title);
  updateMetaTag('twitter:description', description);
  updateMetaTag('twitter:image', imageUrl);
  updateMetaTag('twitter:url', url);
  
  console.log('Meta tags updated for sharing:', {
    title,
    description,
    imageUrl,
    url
  });
}

/**
 * Updates a specific meta tag or creates it if it doesn't exist
 * @param name The name or property of the meta tag
 * @param content The content value to set
 */
function updateMetaTag(name: string, content: string): void {
  // First try to find by property (for Open Graph)
  let meta = document.querySelector(`meta[property="${name}"]`);
  
  // If not found, try by name (for Twitter)
  if (!meta) {
    meta = document.querySelector(`meta[name="${name}"]`);
  }
  
  // If the meta tag exists, update its content
  if (meta) {
    meta.setAttribute('content', content);
  } else {
    // Otherwise, create a new meta tag
    meta = document.createElement('meta');
    
    // Determine if this is an Open Graph or Twitter tag
    if (name.startsWith('og:')) {
      meta.setAttribute('property', name);
    } else {
      meta.setAttribute('name', name);
    }
    
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
  }
}

/**
 * Resets meta tags to their default values
 */
export function resetMetaTags(): void {
  try {
    const defaultTitle = 'SnapVote - Make Better Decisions Together';
    const defaultDescription = 'Create engaging polls, gather meaningful insights, and make better decisions together. Join the community of curious minds and decision makers.';
    const defaultImage = '/og-default.jpg';
    const defaultUrl = window.location.origin;
    
    updateMetaTags(defaultTitle, defaultDescription, defaultImage, defaultUrl);
    console.log('Meta tags reset to defaults');
  } catch (error) {
    console.error('Error resetting meta tags:', error);
  }
}